import React, { useReducer, useState, useEffect } from "react";
import ClientReducer from "./ClientReducer";
import { createContext } from "react";
import axios from "axios";
import Qs from "qs";
import { useContext } from "react";
import { GlobalContext } from "../GlobalContext";
import { filterByLocation } from "../../utils/locationFilter";
const normalizeProvince = (prov) => prov?.trim().toUpperCase();
const normalizeCountry = (country) => country?.trim();

const initialState = {
  categories: [],
  classes: [],
  // categoryClasses: [],
  subClasses: [],
  classSubClasses: [],
  clients: [],
  loading: false,
  parentId: 0,
  selectedDepartment: null,
  selectedClass: null,
  selectedSubclass: {},
  selectedClient: {},
  isCategorySelected: false,
  isClassSelected: false,
  isSubclassSelected: false,
  isClientSelected: false,
  showCategories: true,
  isShowClientList: false,
  clientList: [],
  isSearchByName: false,
  keywords: "",
  keysArr: [],
  page: 1,
  andOr: true,
  enableShowMore: false,
  displayedClient: {},
  sellGiftcardsFilter: false,
  offerPromotion: false,
  hasWebstore: false,
  classAttributes: [],
  selectedAttributes: [],
  companyNameSearch: "",
  clientListEmpty: false,
};

export const ClientContext = createContext(initialState);

// const gogBaseUrl = "https://localhost:44342/api";
// const idBillFoldBaseUrl = "https://localhost:44311/api";

const gogBaseUrl = process.env.REACT_APP_GOG_URL;

const idBillFoldBaseUrl = process.env.REACT_APP_IDBF_URL;

const localClientState = JSON.parse(localStorage.getItem("clntState"));

export const ClientProvider = ({ children }) => {
  // let localStorageClientState;clientState
  const { address } = useContext(GlobalContext);
  const [state, dispatch] = useReducer(
    ClientReducer,
    localClientState || initialState
  );

  useEffect(() => {
    // localStorageClientState = JSON.parse(localStorage.getItem("clientState"));

    if (localClientState) {
      dispatch({
        type: "GET_CLNT_STATE_FROM_LOCAL",
        payload: JSON.parse(localStorage.getItem("clntState")),
      });
    } else {
      console.log("local storage does not exists");
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "clntState",
      // JSON.stringify({ ...state, disableLimitBtns: false })
      JSON.stringify(state)
    );
  }, [state]);

  const [pg, setPg] = useState(1);

  // Get categories from Marketing database
  const getAllCategories = async () => {
    try {
      const result = await axios.get(gogBaseUrl + "/Department");
      dispatch({ type: "GET_CATEGORIES", payload: result.data });
    } catch (error) {
      console.log(error);
    }
  };

  const getAllClasses = async () => {
    const result = await axios.get(gogBaseUrl + "/Class");
    dispatch({ type: "SET_CLASSES", payload: result.data });
  };

  const getAllSubClasses = async () => {
    const result = await axios.get(gogBaseUrl + "/SubClass");
    dispatch({ type: "SET_SUBCLASSES", payload: result.data });
  };

  const fetchAllCatClassSubClass = async () => {
    await getAllCategories();
    await getAllClasses();
    await getAllSubClasses();
  };

  const getClassClients = async (classId, pagex) => {
    const results = await axios.get(
      gogBaseUrl + `/Client?classId=${classId}&page=${pagex}`,
      {
        params: {
          GftCrd: state.sellGiftcardsFilter,
          Promo: state.offerPromotion,
          Webstore: state.hasWebstore,
        },
      }
    );
    let list = results.data;
    list = filterByLocation(list, address);
    return list;
  };

  const getClientsByKeywords = async (keywordArr, any) => {
    setPg(1);
    let params = {
      keyArr: keywordArr,
      MatchAny: any,
      // classId: state.selectedClass.id,
      GftCrd: state.sellGiftcardsFilter,
      Promo: state.offerPromotion,
      Webstore: state.hasWebstore,
    };

    let myAxios = axios.create({
      paramsSerializer: (params) =>
        Qs.stringify(params, {
          arrayFormat: "repeat",
        }),
    });

    let res = [];

    try {
      res = await myAxios.get(gogBaseUrl + `/Client`, {
        params,
      });

      let list = res.data;
      list = filterByLocation(list, address);
      dispatch({ type: "SHOW_CLIENT_LIST" });
      dispatch({ type: "SET_CLIENT_LIST", payload: list });
      if (list.length < 1) {
        dispatch({ type: "CLIENT_LIST_EMPTY_TRUE" });
      } else {
        dispatch({ type: "CLIENT_LIST_EMPTY_FALSE" });
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getClientsByAttributes = async (attrArr = []) => {
    setPg(1);
    console.log("get clients by attributes called");
    let params = {
      AtrArr: attrArr,
      GftCrd: state.sellGiftcardsFilter,
      Promo: state.offerPromotion,
      Webstore: state.hasWebstore,

      classId: state.selectedClass.id,
    };

    let myAxios = axios.create({
      paramsSerializer: (params) =>
        Qs.stringify(params, {
          arrayFormat: "repeat",
        }),
    });

    let res = [];

    // if (attrArr.length > 0) {
    try {
      res = await myAxios.get(gogBaseUrl + `/Client/attr`, {
        params,
      });

      let list = res.data;
      list = filterByLocation(list, address);

      dispatch({ type: "SHOW_CLIENT_LIST" });
      dispatch({ type: "SET_CLIENT_LIST", payload: list });
    } catch (error) {
      console.log(error);
    }
    // } else {
    //   console.log("no attribute selected");
    // }
  };

  const setLoading = () => dispatch({ type: "SET_LOADING" });
  const clearLoading = () => dispatch({ type: "CLEAR_LOADING" });

  const setSelectedDepartment = (department) =>
    dispatch({ type: "SET_SELECTED_DEPARTMENT", payload: department });

  const setSelectedClass = async (clss) => {
    const res = await getClassClients(clss.id, 1);

    setPg(1);

    dispatch({
      type: "SET_SELECTED_CLASS",
      payload: { class: clss, clients: res },
    });
    dispatch({ type: "CLEAR_SELECTED_CLIENT" });
  };

  const clearSelectedCategory = () => {
    dispatch({ type: "CLEAR_SELECTED_CATEGORY" });
  };

  const getCtgClasses = (id) =>
    dispatch({ type: "FILTER_CLASSES", payload: id });

  /// Subclass SELECTED
  const handleSubClassSelected = async (subclass) => {
    setPg(1);
    const results = await axios.get(
      gogBaseUrl + `/Client/?subclassId=${subclass.id}&page=1`
    );

    const subClassClients = results.data;
    subClassClients = filterByLocation(subClassClients, address);
      dispatch({
      type: "SUBCLASS_SELECTED",
      payload: subclass,
      payload2: subClassClients,
    });

    dispatch({ type: "CLEAR_SELECTED_CLIENT" });
  };

  const clearSelectedClass = () => {
    console.log("Context runs");
    dispatch({ type: "CLEAR_SELECTED_CLASS" });
  };

  const clearSubClass = () => {
    dispatch({ type: "CLEAR_SUBCLASS" });
  };

  const showClientList = () => {
    dispatch({ type: "SHOW_CLIENT_LIST" });
  };
  const hideClientList = () => {
    console.log("hide client list dispatach");
    dispatch({ type: "HIDE_CLIENT_LIST" });
  };

  // INCREMENT PAGE
  const incrementPage = async () => {
    console.log("increment clicked");

    let params = {
      keyArr: state.keysArr,
      MatchAny: state.andOr,
      classId: state.selectedClass.id,
      SubclassId: state.selectedSubclass.id,

      page: pg + 1,
    };

    let myAxios = axios.create({
      paramsSerializer: (params) =>
        Qs.stringify(params, {
          arrayFormat: "repeat",
        }),
    });

    const res = await myAxios.get(gogBaseUrl + `/Client`, {
      params,
    });
    let list = res.data;
    list = filterByLocation(list, address); 
    setPg(pg + 1);

    dispatch({ type: "APPEND_TO_CLIENTS", payload: list });
  };

  /// Filter clients by search limits

  const filterClients = (clients) => {
    let filtered = clients;

    if (state.sellGiftCards) {
      filtered = clients.filter((c) => c.sellGiftCards);
    }
    if (state.offerPromotion) {
      filtered = clients.filter((c) => c.offerPromotion);
    }
    if (state.hasWebstore) {
      filtered = clients.filter((c) => c.hasWebstore != null);
    }

    return filtered;
  };

  // sellGiftcards: false,
  // offerPromotion: false,
  // hasWebstore: false,

  // GET CLIENTS BY COMPANY NAME
  const getClientsByCompanyName = async (companyName) => {
  const result = await axios.get(
    gogBaseUrl + `/Client/?subclassId=&page=&CompName=${companyName}`,
    {
      params: {
        GftCrd: state.sellGiftcardsFilter,
        Promo: state.offerPromotion,
        Webstore: state.hasWebstore,
      },
    }
  );

  let list = result.data;

  // 🚀 Apply location filtering
  const filtered = filterByLocation(list, address);

  dispatch({ type: "SET_CLIENT_LIST", payload: filtered });

  if (filtered.length < 1) {
    dispatch({ type: "CLIENT_LIST_EMPTY_TRUE" });
  } else {
    dispatch({ type: "CLIENT_LIST_EMPTY_FALSE" });
  }

  return filtered;
};


  const clearCategorySearch = () => {
    console.log("Clear company search");
    dispatch({ type: "CLEAR_CATEGORY_SEARCH" });
  };

  const clearCompanyNameSearch = () => {
    console.log("Clear company name search");
    dispatch({ type: "CLEAR_COMPANY_NAME_SEARCH" });
  };

  const clearClientList = () => {
    console.log("clear client list");
    dispatch({ type: "CLEAR_CLIENT_LIST" })
  };

  const setIsSearchByName = (bool) => {
    console.log(bool ? "true" : "false");
    dispatch({ type: "SET_SEARCH_BY_NAME", payload: bool });
  };

  const setSelectedClient = (client) => {
    dispatch({ type: "SET_SELECTED_CLIENT", payload: client });
  };

  const clearSelectedClient = () => {
    dispatch({ type: "CLEAR_SELECTED_CLIENT" });
  };

  const setKeywords = (keywords) => {
    dispatch({ type: "SET_KEYWORDS", payload: keywords });
  };

  const setKeysArr = (keysArr) => {
    dispatch({ type: "SET_KEYS_ARR", payload: keysArr });
  };

  const clearClassSubClassClient = () => {
    dispatch({ type: "CLEAR_CLASS_SUB_CLIENT" });
  };

  // const url = "https://localhost:44342/api/Client/";

  const getClientDetails = async (id) => {
    try {
      var res = await axios.get(gogBaseUrl + "/Client/" + id);

      dispatch({ type: "SET_DISPLAYED_CLIENT", payload: res.data });

      return res.data;
    } catch (error) {
      console.log(error);
    }
  };

const getClientImages = async (id) => {
  // Debugger: return mock JSON for clientId = 4
  if (parseInt(id) === -1) {
    console.warn("⚠ Using MOCK IMAGE DATA for clientId=4");

    const mockImages = [
      {
        "id": 128,
        "clientId": 4,
        "displayOrder": 0,
        "imageName": "7034682225425375.jpg",
        "isLogo": true
      },
      {
        "id": 129,
        "clientId": 4,
        "displayOrder": 0,
        "imageName": "__opt__abo225430452.jpg",
        "isLogo": false
      },
      {
        "id": 130,
        "clientId": 4,
        "displayOrder": 0,
        "imageName": "blog1-1170225438358.png",
        "isLogo": false
      },
      {
        "id": 131,
        "clientId": 4,
        "displayOrder": 0,
        "imageName": "Neapolitan225446813.jpg",
        "isLogo": false
      }
    ];

    // Still set reducer state
    dispatch({ type: "SET_ENTITY_IMAGES", payload: mockImages });

    return mockImages;
  }

  // REAL API CALL FOR ALL OTHER CLIENT IDs
  try {
    const res = await axios.get(idBillFoldBaseUrl + "/Entity/images/" + id);

    dispatch({ type: "SET_ENTITY_IMAGES", payload: res.data });

    return res.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};


  const getClientKeywords = async (clientId) => {
    // var keywordsUrl = "https://localhost:44311/api/Entity/keywords/"; /////

    try {
      var res = await axios.get(
        idBillFoldBaseUrl + "/Entity/keywords/" + clientId
      );
      return res.data;
    } catch (error) {
      return [];
    }
  };

  const getClientCategories = async (clientId) => {
    try {
      var res = await axios.get(gogBaseUrl + "/Client/ctg/" + clientId);

      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const setLimitGiftcard = (limitGiftcard) => {
    dispatch({ type: "SET_SELLGIFTCARDS", payload: limitGiftcard });
  };
  const setOfferpromo = (offerPromo) => {
    dispatch({ type: "SET_OFFERPROMO", payload: offerPromo });
  };
  const setHasWebstore = (haswebstore) => {
    dispatch({ type: "SET_HASWEBSTORE", payload: haswebstore });
  };

  const resetClientContext = () => {
    dispatch({ type: "RESET_CLIENT_CONTEXT", payload: initialState });
  };

  const baseUrl = process.env.REACT_APP_GOG_URL;

  const getClasses = async (id) => {
    try {
      var res = await axios.get(baseUrl + "/Department/" + id + "/classes");
      // setClassList(res.data);
      // return res.data;
      dispatch({ type: "SET_CLASSES", payload: res.data });
    } catch (error) {
      console.log(error);
      dispatch({ type: "SET_CLASSES", payload: [] });
    }
  };

  const getAttributes = async (id) => {
    try {
      var res = await axios.get(
        baseUrl + "/Department/classes/" + id + "/attributes"
      );
      res.data.sort((a, b) => a.displayOrder - b.displayOrder);
      // setAttributes(res.data);
      dispatch({ type: "SET_CLASS_ATTRIBUTES", payload: res.data });

      // return res.data;
    } catch (error) {
      console.log(error);
      dispatch({ type: "SET_CLASS_ATTRIBUTES", payload: [] });
    }
  };

  const setSelectedAttributes = (attributes) => {
    dispatch({ type: "SET_SELECTED_ATTRIBUTES", payload: attributes });
  };
  const clearSelectedAtributes = () => {
    dispatch({ type: "CLEAR_SELECTED_ATTRIBUTES" })
  }
  const setCompanySearchName = (name) => {
    dispatch({ type: "SET_COMP_NAME_SEARCH", payload: name });
  };

  return (
    <ClientContext.Provider
      value={{
        categories: state.categories,
        //  selectedCategory: state.selectedCategory,
        selectedClass: state.selectedClass,
        classes: state.classes,
        // categoryClasses: state.categoryClasses,
        loading: state.loading,
        isDepartentSelected: state.isCategorySelected,
        showCategories: state.showCategories,
        isSubclassSelected: state.isSubclassSelected,
        classSubClasses: state.classSubClasses,
        isClassSelected: state.isClassSelected,
        selectedSubclass: state.selectedSubclass,
        isShowClientList: state.isShowClientList,
        clientList: state.clientList,
        page: state.page,
        isSearchByName: state.isSearchByName,
        selectedClient: state.selectedClient,
        isClientSelected: state.isClientSelected,
        keywords: state.keywords,
        keysArr: state.keyArr,
        enableShowMore: state.enableShowMore,
        displayedClient: state.displayedClient,
        sellGiftcardsFilter: state.sellGiftcardsFilter,
        offerPromotion: state.offerPromotion,
        hasWebstore: state.hasWebstore,
        selectedDepartment: state.selectedDepartment,
        classAttributes: state.classAttributes,
        selectedAttributes: state.selectedAttributes,
        companyNameSearch: state.companyNameSearch,
        clientListEmpty: state.clientListEmpty,
        clearCategorySearch,
        incrementPage,
        getClientsByCompanyName,
        setLoading,
        clearLoading,
        clearSelectedCategory,
        getAllCategories,
        setSelectedDepartment,
        setSelectedClass,
        getAllClasses,
        getCtgClasses,
        fetchAllCatClassSubClass,
        handleSubClassSelected,
        clearSubClass,
        clearSelectedClass,
        showClientList,
        hideClientList,
        clearClientList,
        setIsSearchByName,
        setSelectedClient,
        clearSelectedClient,
        getClientsByKeywords,
        setKeywords,
        setKeysArr,
        clearClassSubClassClient,
        getClientDetails,
        getClientImages,
        getClientKeywords,
        getClientCategories,
        getClientsByAttributes,
        setLimitGiftcard,
        setOfferpromo,
        setHasWebstore,
        resetClientContext,
        getClasses,
        getAttributes,
        setSelectedAttributes,
        setCompanySearchName,
        clearCompanyNameSearch,
        clearSelectedAtributes
      }}
    >
      {children}
    </ClientContext.Provider>
  );
};
